<template>
  <div>
    <attachment-list :adjuntos="comprobantes" :canEdit="canEdit && clubPuedeBorrarAdjuntos" @removedFile="remove" v-if="comprobantes && comprobantes.length">
      Comprobantes de pagos asociados
    </attachment-list>
    <div v-if="canEdit">
      <p class="red--text" v-for="error in fileErrors" :key="error">{{ error }}</p>
      <div class="custom-font-semi-bold custom-text text-grey" v-if="newComprobanteAdded">Comprobante de pago</div>
      <AttachFile ref="fileComprobante" :description="true" @upload="uploadComprobante"></AttachFile>
      <v-btn @click="openFileDirectoryComprobante" color="#1787c9" dark class="attach-button">
        <v-icon>attach_file</v-icon>
        <span>Agregar Comprobante de Pago</span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { requiredIf } from 'vuelidate/lib/validators'
import AttachFile from '../../../common/ui/AttachFile'
import AttachmentList from '../../pago_a_jugadores/components/AttachmentList'

export default {
  props: {
    comprobantes: Array,
    canEdit: Boolean,
    clubPuedeBorrarAdjuntos: Boolean
  },

  components: {
    AttachFile,
    AttachmentList
  },

  mixins: [validationMixin],

  validations () {
    return {
      files: {
        required: requiredIf(() => {
          return this.doesNotHavePreviousAttachments && !this.hasAddedFiles() && !this.isLoading() && !this.adjuntos.optional
        })
      }
    }
  },

  data () {
    return {
      files: [],
      comprobante: [],
      removedFiles: [],
      itemId: [],
      loading: false
    }
  },

  computed: {
    fileErrors () {
      const errors = []
      if (!this.$v.files.$dirty) return errors
      !this.$v.files.required && errors.push('Adjunto requerido.')
      return errors
    },
    newComprobanteAdded () {
      return this.hasAddedComprobante()
    }
  },
  methods: {
    uploadComprobante (newFiles) {
      this.$emit('adjuntosModificados')
      this.comprobante = newFiles
    },
    openFileDirectoryComprobante () {
      this.$refs.fileComprobante.onPickFile()
    },
    remove (itemId) {
      this.$emit('adjuntosModificados')
      this.removedFiles.push(itemId)
    },
    isValid () {
      this.$v.$touch()
      return !this.$v.$invalid
    },
    isLoading () {
      return this.loading
    },
    hasAddedComprobante () {
      return this.comprobante.length > 0
    },
    hasAddedFiles () {
      return this.hasAddedComprobante()
    },
    hasRemovedFiles () {
      return this.removedFiles.length > 0
    },
    getAddedComprobante () {
      return this.comprobante
    },
    getRemovedFiles () {
      return this.removedFiles
    },
    getModifiedFiles () {
      return []
    },
    cleanAddedFiles () {
      this.$refs.fileInput.cleanContent()
      this.files = []
    },
    cleanRemovedFiles () {
      this.removedFiles = []
    },
    cleanModifiedFiles () {},
    startLoading () {
      this.loading = true
    },
    finishLoading () {
      this.loading = false
    }
  }
}
</script>

<style scoped>
a {
  color: #1787c9;
}
.attach-button {
  font-size:0.9em;
  padding-left: 0.6em;
}
.row-element {
  background-color: #f0f0f2;
}
.custom-font-semi-bold {
  font-family: SourceSansProSemiBold, sans-serif;
}
.custom-text {
  margin: 0.5em 0 0.5em 0.2em;
  font-size: 1.1em;
}
.text-grey {
  color: #413d3d;
}
</style>
